export default {
  emptyApplication: {
    "purchase-approval": {},
    "purchase-preapproval": {},
    "refinance-approval": {},
    "switch-transfer": {}
  },
  application: {},
  rawApplication: {},
  schema: {
    pages: {
      byKey: {},
      allKeys: []
    },
    metadata: {}
  },
  loadedInLocal: false,
  rawSchema: {},
  applicationDetails: {},
  disclaimers: [],
  acceptedConsents: {},
  applicationValidations: [],
  applications: {
    byId: {},
    allIds: []
  },
  consolidatedRequest: {},
  applicationVuelidations: {},
  acceptedTOS: false
};